export const literal = `<div class="header">
    <p class="text lg bold"><code>poke-card</code></p>
</div>
<div class="body">
    <p class="text sm">
        .this card will take the width of its content.
    </p>
</div>
<div class="footer">
    <p class="text md bold right">footer</p>
</div>`

export const effectLiteral = `<div class="header">
    <p class="text lg bold light"><code>poke-card</code></p>
</div>
<div class="body">
    <p class="text sm light">
        .this card will take the width of its content.
    </p>
</div>
<div class="footer">
    <p class="text md bold right light">footer</p>
</div>`

export const card = `<div class="card">
    <div class="header">
        <p class="text lg bold"><code>poke-card</code></p>
    </div>
    <div class="body">
        <p class="text sm">
            .this card will take the width of its content.
        </p>
    </div>
    <div class="footer">
        <p class="text md bold right">footer</p>
    </div>
</div>`

export const cardHalf = `<div class="card half">
    <div class="header">
        <p class="text lg bold"><code>.card.half</code></p>
    </div>
    <div class="body">
        <!-- content -->
    </div>
    <div class="footer">
        <p class="text md bold right">footer</p>
    </div>
</div>`

export const cardWide = `<div class="card wide">
    <div class="header">
        <p class="text lg bold"><code>.card.half</code></p>
    </div>
    <div class="body">
        <!-- content -->
    </div>
    <div class="footer">
        <p class="text md bold right">footer</p>
    </div>
</div>`

export const auto = `<div class="card auto">
    <div class="header">
        <p class="text lg bold"><code>poke-card</code></p>
    </div>
    <div class="body">
        <p class="text sm"> .this card will place itself on center </p>
    </div>
    <div class="footer">
        <p class="text md bold right">footer</p>
    </div>
</div>`

export const imageHeader = `<div class="card half auto">
    <div class="header img">
        <img src="https://images.pexels.com/photos/416179/pexels-photo-416179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" alt="bird" />
    </div>
    <div class="body">
        <!-- content -->
    </div>
    <div class="footer">card.half.auto</div>
</div>`

export const imageFull = `<div class="card half auto">
    <div class="full-img">
        <img src="https://images.pexels.com/photos/151511/pexels-photo-151511.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" alt="eagle" />
    </div>
    <div class="caption">
        <div class="message">
            <p class="text xl center">Eagle</p>
            <p class="text md center">Description</p>
        </div>
    </div>
</div>`